





























import VueOptions from '@utils/VueOptions'
import VendorListingThumbnail from '@ui/cards/VendorListingThumbnail'
import FeedCardCenter from '@ui/Campaign/pipeline/EventFeed/FeedCardCenter'
import VendorListingsPricingDisplay from '@ui/Campaign/pipeline/EventFeed/activation/VendorListingsPricingDisplay'

settings =
  name: 'VendorListingCard'

  vue:
    props: ['item', 'activationPlans', 'actions']

    components: {
      VendorListingThumbnail,
      FeedCardCenter,
      VendorListingsPricingDisplay,
    }

    computed:
      activationPlanId: -> "#{@$route.params.campaignId}:#{@vendorListing.id}:"
      activationPlan: -> @activationPlans.find((plan) => plan.id is @activationPlanId)
      vendorListing: -> @ctxVendorListing @item

    methods:
      hiNavigateToVendorListingDetails: ->
        { campaignId, tab } = @$route.params
        params = { campaignId, tab, vendorListingId: @vendorListing.id }
        @$router.push { name: 'CampaignCheckoutVendorListingShow', params }

export default VueOptions.vue settings
